<template>
  <div>
    <header id="bg-header" class="bg-header haslayout">
      <div class="topbar">
        <div class="container">
          <div class="row">
            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
              <ul class="tg-addnav">
                <li>
                  <i class="fas fa-phone-volume fa-lg"></i>
                  <span>Call: {{getHeaderFooterData.mobile_no}}</span>
                </li>
                <li>
                  <i class="far fa-envelope fa-lg"></i
                  ><span> {{getHeaderFooterData.email}}</span>
                </li>
              </ul>
              <div class="userlogin" v-if="!getLoggedInStatus">
                <i class="fas fa-user-lock"></i>
                <a @click="loginMethodFromHead()">Login</a>
              </div>
              <div class="userlogin dropdown" v-if="getLoggedInStatus">
                    <ul>
                      <li
                        class="menu-item-has-children menu-item-has-mega-menu"
                      >
                        <figure>
                          <a href="#">
                            <v-img
                              v-if="userName.profile_image == null"
                              src="../../assets/images/imag-27.jpg"
                              alt="image description"
                              height= '30px'
                              width= '30px'
                            ></v-img>
                            <v-img
                              v-if="userName.profile_image != null"
                              :src="`${baseURL2}/${userName.profile_image}`"
                              alt="image description"
                              height= '30px'
                              width= '30px'
                            ></v-img>
                          </a>
                        </figure>
                        <span class="allbutton-btnthemedropdown2"
                          >{{userName.name}}</span
                        >
                        <div class="mega-menu">
                          <ul class="themetabnav" role="tablist">
                            <li role="presentation" class="active">
                              <a  @click="logoutMethod()">Logout</a>
                              
                            </li>
                          </ul>
                        </div>
                      </li>
                    </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="navigationarea">
        <div class="container">
          <div class="row">
            <div class="col-12 col-xs-12 col-sm-12 col-md-12 col-lg-12">
              <div class="st-main-header-in">
                <div class="st-main-header-left">
                  <a class="st-site-branding" href="/"
                    ><img src="../../assets/images/bd_logo.png" alt="logo"
                  /></a>
                </div>
                <div class="st-main-header-right">
                  <nav id="bg-nav" class="bg-nav">
                    <div class="navbar-header">
                      <button
                        @click="openHeaderMenu"
                        type="button"
                        class="navbar-toggle collapsed"
                        data-toggle="collapse"
                        data-target="#navigation"
                        aria-expanded="false"
                      >
                        <span class="sr-only">Toggle navigation</span>
                        <span class="icon-bar"></span>
                        <span class="icon-bar"></span>
                        <span class="icon-bar"></span>
                      </button>
                    </div>
                    <div
                      :class="
                        isMobileMenuIcon
                          ? 'navbar-collapse navigation collapse in bg-white'
                          : 'navbar-collapse navigation collapse'
                      "
                      id="navigation"
                    >
                      <ul>

                        <li class=""><a href="/">Home</a></li>
<!--                        <li><a href="/">E-Library</a></li>-->
                        <!-- <li v-if="getResponsiveLastLimit > 576"><a href="/admin/student-list">User Management</a></li> -->
                        <li v-if="getLoggedInStatus && getResponsiveLastLimit > 576"><a  @click="dashBoardMethod()">Dashboard</a></li>
                        <li><a href="/institute-profile">Institutes</a></li>
                        <li><a href="/web-portal-list">Content</a></li>
                        <li><a  href="/blog">Blog</a></li>
                        <li><a href="/faq">FAQ</a></li>
                      </ul>
                    </div>
                  </nav>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  </div>
</template>

<script>
import $ from "jquery";
$(".userlogin").on("click", () => {
 //  console.log("hi");
});
import { baseURL2 } from "../../store/api";

export default {
  name: "WebPortalHeader",
  
  data() {
    return {
      isMobileMenuIcon: false,
      logOutSuccess:false,
      userName:{},
      baseURL2: baseURL2,
    };
  },
  created() {
   let myToken = localStorage.getItem('dgmeToken');
    if(myToken && myToken != 'null'){
      this.userName = JSON.parse(localStorage.getItem('currentUser'));
    }
  },
  computed:{
    getLoggedIn(){
      return this.$store.getters.getLoggedIn;
    },
    getHeaderFooterData(){
      return this.$store.getters.getHeaderFooterPublicData;
    },
    getLoggedInStatus() {
      return window.localStorage.getItem("dgmeToken") ? true : false;
    },
    getResponsiveLastLimit(){
      return window.innerWidth;
    }
  },
  methods: {
    openHeaderMenu: function () {
     //  console.log("hi");
      let _that = this;
      _that.isMobileMenuIcon = !_that.isMobileMenuIcon;
    },

    loginMethodFromHead(){
      ////  console.log("xadada");
      var currentUrl = "/"
       localStorage.setItem("currentUrl", currentUrl);
       this.$router.push("/login");
    },
    logoutMethod() {
     //  console.log("hi ");
      // this.setLimit();

      this.$store.dispatch("logOutUser").then((data) => {
        if (data) {
          this.logOutSuccess = true;
          window.location.reload();
          // this.$store.commit("SET_LOGGED_IN", true);
        }
        if (this.logOutSuccess) {
          localStorage.removeItem("dgmeToken");
        }
      });
    },

    dashBoardMethod(){

        let myToken = localStorage.getItem('dgmeToken');
        let currentUser=JSON.parse(localStorage.getItem('currentUser'))
        if(!myToken){
              this.$router.push("/login");
            }
            else{
        this.$store.dispatch("callfacilityDashboardData").then((data) => {
        
            if(data.type == "teacher_dashboard"){
              localStorage.setItem("thisDashboard", "/admin/teacher-dashboard");
              this.$router.push("/admin/teacher-dashboard");
            }
            
             if(data.type == "student_dashboard"){
             //  console.log("data.type",data.type);
             localStorage.setItem("thisDashboard", "/admin/student-dashboard");
              this.$router.push("/admin/student-dashboard");
            }
            if(data.type == "institute_admin_dashboard"){
              localStorage.setItem("thisDashboard", "/admin/institute-dashboard");
              this.$router.push("/admin/institute-dashboard");
            }
             if(data.type == "admin_dashboard"){
              localStorage.setItem("thisDashboard", "/admin/admin-dashboard");
              this.$router.push("/admin/admin-dashboard");
            }
            //  else {
            //    localStorage.setItem("thisDashboard", "/admin/institute-dashboard");
            //   this.$router.push("/admin/institute-dashboard");
            // }
          
       });}
         // this.$store.dispatch("callfacilityDashboardData");
       //  console.log("myToken",myToken);
      if(myToken != "null"){
       //  console.log("crnt", currentUser)
     
       
    }
    
     

     else{
      //  console.log("dont");
       var currentUrl = "/"
       localStorage.setItem("currentUrl", currentUrl);
       this.$router.push("/login");
     }

    }
  },
};
</script>

<style scoped>
.st-main-header-in {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content: space-between;
  height: 60px;
}
.bg-white {
  background: #ffffff;
  z-index: 999;
}
.v-application ul,
.v-application ol {
  padding-left: 0;
}
li.menu-item-has-children:hover > .sub-menu,
li.menu-item-has-children:focus > .sub-menu,
li.menu-item-has-children:hover > .mega-menu {
  top: 100%;
  opacity: 1;
  visibility: visible;
}

li.menu-item-has-children:focus > .mega-menu {
  top: 100%;
  opacity: 1;
  visibility: visible;
}
a.st-site-branding img {
  height: 60px;
  width: auto;
}
</style>
